module.exports = __webpack_public_path__ + "kudos_37.svg?dfd8d58a13c861775ee97cfdbdc32b3d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_37.svg
// module id = 136
// module chunks = 0